import { render, staticRenderFns } from "./ProductItemBox.vue?vue&type=template&id=25fba527&scoped=true"
import script from "./ProductItemBox.vue?vue&type=script&lang=js"
export * from "./ProductItemBox.vue?vue&type=script&lang=js"
import style0 from "./ProductItemBox.vue?vue&type=style&index=0&id=25fba527&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fba527",
  null
  
)

export default component.exports